import { IPopularItems } from "../../ISearch";

export const popularItemsEn: Array<IPopularItems> = [
  {
    label: "Chicken",
    href: "/search?s=chicken"
  },
  {
    label: "Keto",
    href: "/search?s=keto"
  },
  {
    label: "Cake",
    href: "/search?s=cake"
  },
  {
    label: "Salad",
    href: "/search?s=salad"
  },
  {
    label: "Bread",
    href: "/search?s=bread"
  },
  {
    label: "Pizza",
    href: "/search?s=pizza"
  },
  {
    label: "Breakfast",
    href: "/search?s=breakfast"
  },
  {
    label: "High protein",
    href: "/search?s=high+protein"
  },
  {
    label: "Guides",
    href: "/low-carb/keto/guides"
  },
  {
    label: "Videos",
    href: "/video"
  }
];
